import { IonText } from '@ionic/react';
import { useEffect, useMemo, useState } from 'react';

import { CircleAnimation } from '@/components/CircleAnimation/CircleAnimation';

import styles from './ActiveRecordingTimer.module.css';

interface ActiveRecordingTimerProps {
  /** The unix timestamp of the start time of the recording */
  startTime: number;
}
export const ActiveRecordingTimer = ({ startTime }: ActiveRecordingTimerProps) => {
  const [elapsed, setElapsed] = useState(0);

  useEffect(() => {
    const updateTimer = () => {
      // Function to calculate the new elapsed time based on current time minus start time
      setElapsed(Date.now() - startTime);
    };

    // Start an interval that updates the elapsed time every 1000ms we do this often so that it feels like the seconds go up consistently
    const interval = setInterval(updateTimer, 250);

    // Call the updateTimer function initially to set the initial elapsed time
    updateTimer();

    // Clean up the interval when the component is unmounted
    return () => clearInterval(interval);
  }, [startTime]);

  const minutes = useMemo(() => Math.floor(elapsed / 60000), [elapsed]);
  const seconds = useMemo(() => Math.floor(elapsed / 1000) % 60, [elapsed]);

  const numberFormatter = new Intl.NumberFormat('en-US', {
    minimumIntegerDigits: 2,
    useGrouping: false,
  });

  return (
    <div className={styles.wrapper}>
      <CircleAnimation className={styles.loading} />
      <IonText className={styles.time}>
        {minutes}:{numberFormatter.format(seconds)}
      </IonText>
    </div>
  );
};
